import React, {useEffect, useState} from 'react'
import utf8 from 'utf8'
import base64 from 'base-64'
import DemoForm from './DemoForm'
import CallToActionForm from "../template4/CallToActionForm"
import * as cheerio from "cheerio";

const CustomHTML = (props) => {
  const [ShowCallToActionForm, SetShowCallToActionForm] = useState(false)
  useEffect(() => {
    window.showModalFunction = () => {
      SetShowCallToActionForm(true);
    };
    return () => {
      delete window.showModalFunction; // Clean up function on unmount
    };
  }, []);
  function stripHTML(htmlString) {
    return htmlString.replace(/<[^>]*>?/gm, '')
  }

  function removeEmptyPTags(htmlString) {
    const $ = cheerio.load(htmlString);
    $("p").each(function () {
      if (!$(this).text().trim()) {
        $(this).remove();
      }
    });
  
    return $.html();
  }

  function replacePlaceholderWithButton(decodedHTML) {
    return decodedHTML.replace(
      /{{CallToAction_DemoForm}}/g,
      `<div class="callToActionBtnContainer">
        <button class="callToActionDemoButton" onclick="window.showModalFunction()">Schedule a demo</button>
      </div>`
    );
  }

  const content = props?.cProps?.map((item, key) => {
    if (item?.Type === 'HTML') {
      let value = stripHTML(item?.Data)
      let decoded = value ? utf8.decode(base64.decode(value)) : ''
      let cleanedHTML = removeEmptyPTags(decoded);
      let modifiedHTML = replacePlaceholderWithButton(cleanedHTML);

      return <div key={key} dangerouslySetInnerHTML={{ __html: `<div>${modifiedHTML}</div>` }} />
    } 
    
    if (item?.Type === 'DemoForm') {
      let HTML = item?.Data ? utf8.decode(base64.decode(item?.Data)) : ''
      let trackingInfo = item?.TrackingInfo?.AfterSubmissionForm_Tracking || []
      let gtmValue = ''
      let capterraVal1 = ''
      let capterraVal2 = ''

      trackingInfo.forEach(track => {
        if (track?.Type === 'GTM') gtmValue = track?.Value1
        if (track?.Type === 'Capterra') {
          capterraVal1 = track?.Value1
          capterraVal2 = track?.Value2
        }
      })

      return <DemoForm key={key} refererPath={props.refererPath} Html={HTML} tagManager={gtmValue} capterraVal1={capterraVal1} capterraVal2={capterraVal2} />
    }

    return null
  })

  return (
    <div>
      {content}
      <CallToActionForm refererPath={props.refererPath} show={ShowCallToActionForm} onHide={() => SetShowCallToActionForm(false)} />
    </div>
  )
}

export default CustomHTML
